import type { TrainingLessonSpecific } from './trainingLessonUi';

export const elder2LeadershipEn: TrainingLessonSpecific = {
  intro:
    'Leadership in the priesthood is moral influence, not position. An elder leads without dominating, supports leaders, walks with the weak, and cares for family. Consistency beats charisma.',
  objectives: [
    'Lead without dominating.',
    'Support ward leaders.',
    'Accompany the weak.',
    'Care for family spiritually.',
    'Create a personal plan for servant leadership.',
  ],
  briefHeading: 'Servant leadership in brief',
  briefBody:
    'Persuade with meekness, serve first, and be loyal to those who preside. Priesthood leadership builds up; it does not control.',
  scriptures: [
    { ref: 'D&C 121:34–46', text: '…only by persuasion, by long-suffering, by gentleness and meekness…' },
    { ref: 'John 13:14–15', text: '…if I then, your Lord and Master, have washed your feet… ye also ought to wash one another’s feet.' },
    { ref: 'D&C 107:99–100', text: 'Wherefore, now let every man learn his duty, and to act in the office in which he is appointed, in all diligence.' },
    { ref: 'Alma 17:11', text: 'Be patient in afflictions; show good examples; the Lord will make you instruments for salvation.' },
    { ref: 'D&C 58:27', text: '…be anxiously engaged in a good cause…' },
  ],
  didYouKnow: [
    'Leadership in the priesthood is moral influence, not position.',
    'Consistency beats charisma.',
  ],
  practiceItems: [
    'Do a hidden act of service (no one needs to know)',
    'Give counsel humbly when asked',
    'Establish a simple family spiritual plan (prayer, scripture, home evening)',
    'Coordinate with leaders to learn how to support',
    'Offer one-to-one mentoring to someone younger or newer',
    'Weekly review: what went well and what will I improve?',
  ],
  reflectionQuestions: [
    'How am I serving today? What would I change?',
    'Where should I grow as a servant leader?',
    'Who can I mentor or accompany?',
  ],
  actionText: 'Choose one person to accompany for 30 days.',
};
